// * Base
import { FormArray, FormGroup } from '@angular/forms';
import { Injectable, Inject } from '@angular/core';

import { SERVER_ERRORS_CONFIG_TOKEN, SntServerErrorsModuleConfig } from './config';
import {
  excludeKeys,
  SntServerError,
  mapNestedErrors,
  retrieveFormErrors,
  SntServerErrorFilterFn,
} from './server-errors.helpers';

@Injectable()
export class SntServerErrorsService {
  constructor(@Inject(SERVER_ERRORS_CONFIG_TOKEN) private config: SntServerErrorsModuleConfig) {}

  mapErrors(form: FormGroup | FormArray, errors: SntServerError, filterFn?: SntServerErrorFilterFn) {
    this.mapErrorsToForm(form as FormGroup, errors, filterFn);
    this.mapErrorsToFormControls(form, errors, filterFn);
  }

  mapErrorsToFormControls(form: FormGroup | FormArray, errors: SntServerError, filterFn?: SntServerErrorFilterFn) {
    errors = this._preprocessErrors(errors, filterFn);

    const fields = Object.keys(errors);

    for (const field of fields) {
      mapNestedErrors(form, field, [field], errors);
    }
  }

  mapErrorsToForm(form: FormGroup, errors: SntServerError, filterFn?: SntServerErrorFilterFn) {
    errors = this._preprocessErrors(errors, filterFn);
    const formErrors = retrieveFormErrors(form, errors);

    if (formErrors.length) {
      form.setErrors({ server: formErrors });
    }
  }

  private _preprocessErrors(errors: SntServerError, filterFn?: SntServerErrorFilterFn) {
    let preprocessed = errors;

    if (typeof (errors as unknown) === 'string' && errors) {
      preprocessed = JSON.parse(errors as unknown as string);
    }

    if (Array.isArray(this.config.excludeKeys)) {
      preprocessed = excludeKeys(this.config.excludeKeys)(preprocessed);
    }

    if (filterFn) {
      preprocessed = filterFn(preprocessed);
    }

    return preprocessed;
  }
}
